import { render, staticRenderFns } from "./SectionGender.vue?vue&type=template&id=8cfbf7a0"
import script from "./SectionGender.vue?vue&type=script&lang=ts"
export * from "./SectionGender.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports